/*
  Nice Candy: Express-Knöpfe in der Warenkorbschublade ohne Shop Pay.
  Shopify zeichnet die Knöpfe nach der Liste im Attribut wallet-configs (Shop Pay, PayPal, Apple Pay oder Google Pay).
  Wir nehmen Shop Pay aus der Liste und setzen das Element neu ein, dann teilen sich die übrigen Knöpfe die Reihe.
  Shop Pay bleibt in Shopifys Kasse weiterhin verfügbar. Gilt nur für .nc-express-checkout (blocks/_cart-checkout.liquid).
*/
(function () {
  if (window.ncExpressInit) return;
  window.ncExpressInit = true;

  var HIDE = ['shop_pay'];

  function fix() {
    document.querySelectorAll('.nc-express-checkout shopify-accelerated-checkout-cart:not([data-nc-done])').forEach(function (el) {
      el.setAttribute('data-nc-done', '');
      var configs;
      try { configs = JSON.parse(el.getAttribute('wallet-configs') || '[]'); } catch (e) { return; }
      var kept = configs.filter(function (w) { return HIDE.indexOf(w.name) === -1; });
      if (kept.length === configs.length || kept.length === 0) return;
      var fresh = document.createElement('shopify-accelerated-checkout-cart');
      for (var i = 0; i < el.attributes.length; i++) {
        var a = el.attributes[i];
        fresh.setAttribute(a.name, a.name === 'wallet-configs' ? JSON.stringify(kept) : a.value);
      }
      el.replaceWith(fresh);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fix(); });
  }

  fix();
  // Die Schublade baut ihren Inhalt nach jeder Änderung neu auf, dann erneut anpassen
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
